<template>
  <div class="asc-analytic-grid-wrapper--container">
    <div>
      <template>
        <v-row>
          <v-col
            ><asc-surface-title
              class="asc-user-mgmt-wrapper--title"
              title="USER MANAGEMENT"
            />
          </v-col>
          <v-col v-if="!disabled">
            <asc-accent-button
              class="asc-user-mgmt-wrapper--button"
              button-text="Add User"
              :on-click="addUser"
            ></asc-accent-button>
          </v-col>
        </v-row>
      </template>
    </div>
    <div class="asc-analytic-grid-wrapper--grid">
      <asc-user-management-grid
        :values="values"
        :airline-lengths="airlineLengths"
        :on-open="onOpen"
        :add-user="addUser"
        :grid-columns="gridColumns"
        :grid-filters="gridFilters"
        :disabled="disabled"
      ></asc-user-management-grid>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscContainer from '@/components/atoms/AscContainer'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'
import AscUserManagementGrid from '@/components/molecules/AscUserManagementGrid'

export default {
  name: 'AscUserManagementGridWrapper',

  components: {
    AscUserManagementGrid,
    AscContainer,
    AscSurfaceTitle,
    AscAccentButton,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'User Management',
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
    addUser: {
      type: Function,
      default: () => {},
    },
    airlineLengths: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-analytic-grid-wrapper--container {
  .asc-user-mgmt-wrapper {
    &--title {
      padding-top: 10px;
      vertical-align: center;
    }

    &--button {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
    }
  }
  .asc-analytic-grid-wrapper--grid {
    padding-bottom: 12px;
  }
}
</style>
